<template lang="pug">
  div
    h1 404
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss">

</style>
